import { render, staticRenderFns } from "./card-header-records.vue?vue&type=template&id=2743f675&"
import script from "./card-header-records.vue?vue&type=script&lang=js&"
export * from "./card-header-records.vue?vue&type=script&lang=js&"
import style0 from "./card-header-records.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "card-header-records.vue"
export default component.exports